import React, { useState, useEffect, useCallback } from 'react';
import fetch from './fetcher';
import Loading from '../components/common/icons/Loading';
import Error from '../components/common/icons/Error';
import ServerErrorMessage from '../components/common/ServerErrorMessage';


const useFetch = (url, openModal) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const update = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch(url);
      const resData = await res.json();
      setData(resData);
    } catch (e) {
      openModal(ServerErrorMessage, () => {}, e);
    } finally {
      setLoading(false);
    }
  }, [url, openModal]);

  // Please do not rewrite this as useEffect(update) -> there will be a warning
  useEffect(() => { update(); }, [update]);

  const render = Content => {
    if (loading) {
      return <Loading />;
    }
    if (data === null) {
      return <Error />;
    }
    return Content(data);
  };

  return { data, update, render };
};

export default useFetch;
